import React, { useEffect, useState } from 'react'
import './table.scss'
import { connect } from 'react-redux'
import IconUrl from '../../../../../../asset/User-Profile_Solid_E5E5E5_SVG.png'
import SearchAssigne from '../searchAssigne'
import { openAssignSubscription, closeAssignSubscription } from '../../../../../action/sub-showAssigne-action'
import { fetchAssignedSubscription } from '../../../../../action/subscription-api'
import CancelPopUp from '../cancelPopUp'
import Loader from '../../../../recreationAccess/reusableComponents/loader/Loader'
import moment from 'moment'
import superagent from 'superagent'
import { getPurchasedSubscription } from '../../../../../lib/util'

const TableData = (props) => {
  // Resolve the paid plan by plan id rather than array position (the list is not guaranteed to be
  // ordered free-then-paid). See getPurchasedSubscription.
  const purchasedPlan = getPurchasedSubscription(props?.user?.userSubscription)
  const [showAssigne, setShowAssigne] = useState(false)
  const [overflowShown, setOverflowShown] = useState(false);
  const [assignedSubscription, setAssignedSubscription] = useState(props.subscriptionAssigned ? props.subscriptionAssigned : null)
  const [quantity, setQuantity] = useState(purchasedPlan?.quantity)
  const [cancelSubscription, setCancelSubscription] = useState(false)
  const [beforeSuccess, setBeforeSuccess] = useState(false)
  const [revokeSubscription, setRevokeSubscription] = useState(false)
  const [revokeSubscriptionData, setRevokeSubscriptionData] = useState(null)
  const [cancelPopupLoader, setCancelPopupLoader] = useState(false)

  const openAssignSubscription = () => {
    props.openAssignSubscription()
  }

  useEffect(() => {
    setAssignedSubscription(props.subscriptionAssigned)
  }, [props.subscriptionAssigned])

  useEffect(() => {
    if (props.searchString) {
      const filtered = props.subscriptionAssigned.assignedSubscriptions.filter((sub) => {
        return sub.fullName.toLowerCase().includes(props.searchString.toLowerCase())
      }
      );

      setAssignedSubscription(filtered)
    } else {
      setAssignedSubscription(props.subscriptionAssigned)
    }
  }, [props.searchString]);


  useEffect(() => {
    // Wait until transition completes
    const timeout = setTimeout(() => {
      setOverflowShown(true);
    }, 400); // Match the transition duration (600ms)

    return () => clearTimeout(timeout);

  }, []);

  useEffect(() => {
    props.closeAssignSubscription()
  }, [])

  const cancelClose = () => {
    setCancelSubscription(false)
  }

  const cancelRevoke = () => {

    setRevokeSubscription(false)
  }

  const confirmCancel = () => {
    setBeforeSuccess(true)
  }

  const confirmRevoke = () => {
    setCancelPopupLoader(true)
    // api call
    const userId = revokeSubscriptionData.userId;
    const userSubId = getPurchasedSubscription(props.userSubscription)?.id;

    superagent
      .delete(`${__API_URI__}/UserSubscription/Unassign`)

      .query({ userId, userSubId }) // sends ?userId=...&userSubId=...
      .set('Authorization', `Bearer ${props.auth.token}`)
      .then(response => {
        console.log('Successfully unassigned:', response.body);
        purchasedPlan?.id &&
          props.fetchAssignedSubscription(purchasedPlan?.id)
            .then((res) => {
              setBeforeSuccess(true);
              setCancelPopupLoader(false)
            })
            .catch((err) => {
              setBeforeSuccess(true)
              setCancelPopupLoader(false)
            })
      })
      .catch(error => {
        console.error('Error unassigning subscription:', error.response?.body || error.message);
      });
  }

  const onOpenHanleRevoke = (item) => {
    setRevokeSubscription(true)
    setRevokeSubscriptionData(item)
  }

  const okClosePopup = () => {
    setCancelSubscription(false)
    setRevokeSubscription(false)
    setBeforeSuccess(false)
  }

  return (
    <div className={`sub-table-main-container`}>
      {overflowShown &&
        props.loader ?
        <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader> :
        <div className="sub-table-container">
          <table className="subscription-table">
            <thead>
              <tr>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Name</th>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Email</th>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Level</th>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Status</th>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Update</th>
                <th style={{ color: '#C4C4C4', font: 'font: normal normal normal 15px/17px Arial' }}>Expires</th>
              </tr>
            </thead>
            <tbody>

              {!props.searchString && <tr key={1}>
                <td className="user-info">
                  <img
                    src={props.user?.imageProfileUrl || IconUrl}
                    alt="avatar"
                    onError={(e) => {
                      e.currentTarget.onerror = null; // prevent infinite loop
                      e.currentTarget.src = IconUrl;  // fallback
                    }}
                  />
                  <span style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{props.user.fullName}</span>
                </td>
                <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{props.user.email}</td>
                <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }} >{assignedSubscription?.subscriptionName == "Pro Bundle" ? 'PRO ULTIMATE' : assignedSubscription?.subscriptionPlanId == 36 ? 'PRO ADVANTAGE' : 'PRO'}</td>
                {/* <td>Active</td> */}
                <td className="admin-text" style={{ cursor: 'pointer', color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }} onClick={() => onOpenHanleRevoke(item)}>Owner</td>
                <td className="admin-text" style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }} >-</td>
                <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>
                  {
                    (() => {
                      const raw = assignedSubscription?.expires?.trim() || '';
                      const date = moment(raw); // no format, no strict mode
                      return date.isValid() ? date.format('MM-DD-YYYY') : '';
                    })()
                  }
                </td>
              </tr>}

              {!props.searchString ? assignedSubscription
                // && assignedSubscription.assignedSubscriptions.length > 0 
                &&
                Array.from({ length: quantity - 1 }).map((_, index) => {
                  const item = assignedSubscription?.assignedSubscriptions?.[index];
                  if (item) {
                    // Assigned seat
                    return (
                      <tr key={index}>
                        <td className="user-info" style={{ font: 'font: normal normal normal 15px/17px Arial' }}>
                          {/* <img src={item?.imageProfileUrl ? item.imageProfileUrl : IconUrl} alt="avatar" /> */}
                          <img
                            src={item?.imageProfileUrl || IconUrl}
                            alt="avatar"
                            onError={(e) => {
                              e.currentTarget.onerror = null; // prevent infinite loop
                              e.currentTarget.src = IconUrl;  // fallback
                            }}
                          />

                          <span>{item.fullName}</span>
                        </td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{item.email}</td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{assignedSubscription.subscriptionName == "Pro Bundle" ? 'PRO ULTIMATE' : assignedSubscription.subscriptionPlanId == 36 ? 'PRO ADVANTAGE' : 'PRO'}</td>
                        <td className="admin-text" style={{ color: '#BCEC1A', font: 'font: normal normal normal 15px/17px Arial' }} >ACTIVE</td>
                        <td className="" style={{ cursor: 'pointer', color: '', textDecoration: 'underline', font: 'font: normal normal normal 15px/17px Arial' }} onClick={() => onOpenHanleRevoke(item)}>REVOKE</td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>
                          {
                            (() => {
                              const raw = assignedSubscription?.expires?.trim() || '';
                              const date = moment(raw); // no format, no strict mode
                              return date.isValid() ? date.format('MM-DD-YYYY') : '';
                            })()
                          }
                        </td>
                      </tr>
                    );
                  } else {
                    // Unassigned seat
                    return (
                      <tr key={index}>
                        <td>
                          Seat {index + 2}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <span className="assign-link" style={{ cursor: 'pointer', color: '#9ECC3B', font: 'font: normal normal normal 15px/17px Arial' }} onClick={openAssignSubscription}>Assign</span>
                        </td>
                        <td></td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{assignedSubscription.subscriptionName == "Pro Bundle" ? 'PRO ULTIMATE' : assignedSubscription.subscriptionPlanId == 36 ? 'PRO ADVANTAGE' : 'PRO'}</td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>Open</td>
                        <td></td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}> {
                          (() => {
                            const raw = assignedSubscription?.expires?.trim() || '';
                            const date = moment(raw); // no format, no strict mode
                            return date.isValid() ? date.format('MM-DD-YYYY') : '';
                          })()
                        }</td>
                      </tr>
                    );
                  }
                })
                :
                <>
                  {assignedSubscription && assignedSubscription.length > 0 ? assignedSubscription.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="user-info" style={{ font: 'font: normal normal normal 15px/17px Arial' }}>
                          <img src={item?.imageProfileUrl ? item.imageProfileUrl : IconUrl} alt="avatar" />
                          <span>{item.fullName}</span>
                        </td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{item.email}</td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>{assignedSubscription.subscriptionName == "Pro Bundle" ? 'PRO ULTIMATE' : assignedSubscription.subscriptionPlanId == 36 ? 'PRO ADVANTAGE' : 'PRO'}</td>
                        <td className="admin-text" style={{ cursor: 'pointer', color: '#BCEC1A', font: 'font: normal normal normal 15px/17px Arial' }} >ACTIVE</td>
                        <td className="" style={{ cursor: 'pointer', color: '', font: 'font: normal normal normal 15px/17px Arial' }} onClick={() => onOpenHanleRevoke(item)}>REVOKE</td>
                        <td style={{ color: '#959595', font: 'font: normal normal normal 15px/17px Arial' }}>
                          {
                            (() => {
                              const raw = assignedSubscription?.expires?.trim() || '';
                              const date = moment(raw); // no format, no strict mode
                              return date.isValid() ? date.format('MM-DD-YYYY') : '';
                            })()
                          }
                        </td>
                      </tr>
                    )
                  })
                    :
                    <p className='no-result-found-table'>No Result Found</p>}
                </>}

            </tbody>
          </table>
        </div>
      }

      {revokeSubscription &&
        <CancelPopUp
          cancel={cancelRevoke}
          title={`Revoke user's subscription?`}
          successTitle={`User's subscription has been revoked`}
          remove={confirmRevoke}
          beforeSuccess={beforeSuccess}
          okClosePopup={okClosePopup}
          revokeSubscriptionData={revokeSubscriptionData}
        >
        </CancelPopUp>}

      {cancelPopupLoader && <Loader position={'fixed'} left={'48.5%'} width={'30px'}></Loader>}
    </div>
  )
}


const mapStateToProps = state => ({
  manageSubscription: state.manageSubscription,
  assignSubscriptionTab: state.assignSubscriptionTab,
  userSubscription: state.userSubscription,
  auth: state.auth,
  subscriptionAssigned: state.subscriptionAssigned,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  openAssignSubscription: () => dispatch(openAssignSubscription()),
  closeAssignSubscription: () => dispatch(closeAssignSubscription()),
  fetchAssignedSubscription: (payload) => dispatch(fetchAssignedSubscription(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(TableData)

